<template>
  <section>
    <div class="columns">
      <div class="column">
        <div class="container mt-3">
          <div class="box">
            <section class="hero is-primary welcome is-small mb-4">
              <div class="hero-body">
                <div class="container">
                  <h1 class="title">
                    Dashboard Proceso {{ year
                    }}<i class="fas fa-chart-pie ml-2"></i>
                  </h1>
                </div>
              </div>
            </section>
            <template>
              <div class="columns">
                <div class="column">
                  <b-field label="Filtrar por unidad" class="mb-0">
                    <multiselect v-model="selected_unit"
                                 :options="units"
                                 :custom-label="opt => units.find(x => x.id === opt.id).name"
                                 @input="filterByUnit"
                                 placeholder="Seleccione Unidad"
                                 selectLabel="Presione para seleccionar"
                                 selectedLabel="Seleccionado"
                                 deselectLabel="No se puede deseleccionar"
                                 :allow-empty="false">
                      <template v-slot:noOptions>
                        No existen datos
                      </template>
                    </multiselect>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'ACEPTADA'}"
                      @click="aplicarFiltro('ACEPTADA')"
                  >
                    <header class="card-header has-background-primary">
                      <p class="card-header-title has-text-white">Aceptadas</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[0] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'EMITIDA'}"
                      @click="aplicarFiltro('EMITIDA')"
                  >
                    <header class="card-header has-background-success">
                      <p class="card-header-title has-text-white">Emitidas</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[1] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'DEVUELTA'}"
                      @click="aplicarFiltro('DEVUELTA')"
                  >
                    <header class="card-header has-background-warning">
                      <p class="card-header-title has-text-white">Devueltas</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[2] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                      :class="{'is-selected': filtroActivo === 'EN CURSO'}"
                      @click="aplicarFiltro('EN CURSO')"
                  >
                    <header class="card-header has-background-info">
                      <p class="card-header-title has-text-white">En curso</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[3] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div
                      class="card"
                  >
                    <header class="card-header has-background-danger">
                      <p class="card-header-title has-text-white">Sin iniciar</p>
                    </header>
                    <div class="card-content">
                      <p class="title">
                        {{ indicator_state[4] }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="columns">
              <div class="column is-7">
                <div class="card card-stretch">
                  <header class="card-header is-justify-content-space-between is-align-items-center">
                    <p class="card-header-title">Promedio de horas por área</p>
                  </header>
                  <div class="card-content">
                    <apexchart ref="apexChartComponent" type="bar" :options="options_bar" :series="series_bar"></apexchart>
                  </div>
                </div>
              </div>
              <div class="column is-5">
                <div class="card card-stretch">
                  <header class="card-header is-justify-content-space-between is-align-items-center">
                    <p class="card-header-title">Estados de las solicitudes</p>
                  </header>
                  <div class="card-content">
                    <apexchart type="pie" :options="options_pie" :series="series_pie"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="card card-stretch">
                  <header class="card-header is-justify-content-space-between is-align-items-center">
                    <p class="card-header-title">Promedio Horas Semanales por Departamento</p>
                  </header>
                  <div class="card-content">
                    <apexchart ref="apexChartComponentAcademic" type="bar" :options="option_depto_hours" :series="series_depto_hours"></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading
        :is-full-page="true"
        v-model="isLoading"
        :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import axios from "axios";
export default {
  props: ["year"],
  data() {
    return {
      isLoading: false,
      indicator_state: [0, 0, 0, 0, 0],
      data_faculty: null,
      options_bar: {
        plotOptions: {
          bar: {
            distributed: true // importante para aplicar colores por barra
          }
        },
        chart: {
          id: 'basic-bar',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: ["Docencia", "Investigación y Desarrollo", "Asistencia Técnica", "Perfeccionamiento", "Administración Académica", "Extensión-VIME", "Educación Continua-VIME"]
        },
        colors: ['#00e396', '#008ffb', '#775dd0', '#ff4560', '#feb019', '#ff7675', '#6993ff'],
        legend: {
          show: false
        },
      },
      series_bar: [
        {
          name: 'Horas Promedio',
          data: [0, 0, 0, 0, 0, 0, 0]
        }
      ],
      options_pie: {
        labels: ['Aceptadas', 'Emitidas', 'Devueltas', 'En curso', 'Sin iniciar'],
        colors: ['#00d1b2', '#48c78e', '#ffe08a', '#167df0', '#f14668'],
        legend: {
          position: 'bottom'
        },
      },
      series_pie: [0, 0, 0, 0, 0],
      filtroActivo: null,
      prom_total_eq: [0, 0, 0, 0, 0, 0, 0],
      units: [],
      selected_unit: null,
      indicator_state_faculty: [0, 0, 0, 0, 0],
      option_depto_hours: {
        plotOptions: {
          bar: {
            distributed: true // importante para aplicar colores por barra
          }
        },
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          }
        },

        yaxis: {
          labels: {
            style: {
              fontSize: '10px'
            },
            maxWidth: 350,
            offsetX: -12
          }
        },

        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                formatter: function(val) {
                  // Formatear el valor para mostrar solo un decimal
                  return val.toFixed(1);
                }
              }
            }
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '8px', // Ajusta el tamaño de la fuente
            },
            rotate: -45,
          },
        },
        colors: ['#00e396', '#008ffb', '#775dd0', '#ff4560', '#feb019', '#ff7675', '#6993ff'],
        legend: {
          position: 'top',
        },
      },
      series_depto_hours: [],
    };
  },
  created() {
    this.dashboardData()
  },
  methods: {
    dashboardData() {
      this.isLoading = true
      axios
          .get(`/performances/dashboard-data-faculty/${this.year}.json`)
          .then((response) => {
            this.data_faculty = response.data["faculty_data"]
            // Sumar los valores de indicator_state de cada objeto
            this.data_faculty.forEach(item => {
              for (let i = 0; i < item.indicator_state.length; i++) {
                this.indicator_state[i] += item.indicator_state[i]
              }
            })
            this.series_pie = this.indicator_state
            this.indicator_state_faculty = this.indicator_state
            // Inicializar el arreglo para almacenar las sumas
            let sumaProm = Array(7).fill(0);
            // Contar elementos no cero para calcular promedios correctamente
            let contador = Array(7).fill(0);

            // Sumar todos los valores de prom_total_eq_sem
            this.data_faculty.forEach(item => {
              for (let i = 0; i < item.prom_total_eq_sem.length; i++) {
                sumaProm[i] += item.prom_total_eq_sem[i];
                // Si el valor no es cero, incrementamos el contador
                if (item.prom_total_eq_sem[i] > 0) {
                  contador[i]++;
                }
              }
            });

            // Calcular los promedios
            let prom_total = sumaProm.map((suma, index) => {
              // Calcular el promedio considerando todos los valores (incluyendo ceros)
              return parseFloat((suma / this.data_faculty.length).toFixed(1));
            });

            this.prom_total_eq = prom_total;
            this.$refs.apexChartComponent.updateSeries([
              {
                name: "Horas Promedio",
                data: prom_total
              }
            ]);
            this.units = response.data["units"]
            this.selected_unit = response.data["units"].find(x => x.cost_center === 40)

            let unit_name = this.data_faculty.map(x => x.unit.name)
            this.$refs.apexChartComponentAcademic.updateOptions({
              xaxis: {
                categories: unit_name // Actualiza los nombres del eje x
              }
            })
            this.$refs.apexChartComponentAcademic.updateSeries([
              {
                name: "Docencia",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[0])
              },
              {
                name: "Investigación y Desarrollo",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[1])
              },
              {
                name: "Asistencia Técnica",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[2])
              },
              {
                name: "Perfeccionamiento",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[3])
              },
              {
                name: "Administración Académica",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[4])
              },
              {
                name: "Extensión-VIME",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[5])
              },
              {
                name: "Educación Continua-VIME",
                data: this.data_faculty.map(x => x.prom_total_eq_sem[6])
              }
            ])
          })
          .catch((error) => {
            console.log(error);
            this.$buefy.dialog.alert({
              title: "Error",
              message: "Error al obtener los datos.",
              confirmText: "OK",
              type: "is-danger",
            });
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    aplicarFiltro(estado) {
      // Si ya está activo este filtro, lo desactivamos
      if (this.filtroActivo === estado) {
        this.filtroActivo = null;

        // Restaurar los datos originales sin filtro
        this.filterByUnit()
      } else {
        // Activar el filtro
        this.filtroActivo = estado;

        // Obtener datos filtrados y actualizar el gráfico
        const datosFiltrados = this.filtrarPromedioPorEstado(estado);
        this.$refs.apexChartComponent.updateSeries([
          {
            name: "Horas Promedio",
            data: datosFiltrados
          }
        ]);
      }
    },

    filtrarPromedioPorEstado(estado) {
      let academicos = []
      let datos_totales = null
      if(this.selected_unit.cost_center === 40){
        datos_totales = this.data_faculty
      }
      else{
        datos_totales = this.data_faculty.filter(x => x.unit.id === this.selected_unit.id)
      }

      datos_totales.forEach(item => {
        const academics = item.academic_average_hours_equiv.filter(item =>
            item.state_name.toLowerCase() === estado.toLowerCase()
        );
        if(academics.length > 0){
          academics.forEach(academic => {
            academicos.push(academic)
          })
        }
      })
      if (academicos.length === 0){
        return [
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ];
      }
      // Calcular promedios por área
      const promedio = {
        docencia: 0,
        investigacion: 0,
        asistencia: 0,
        perfeccionamiento: 0,
        administracion: 0,
        extension: 0,
        educacion: 0,
      };

      // Sumar todas las horas por área
      academicos.forEach(item => {
        promedio.docencia += parseFloat(item.hours_docencia) || 0;
        promedio.investigacion += parseFloat(item.hours_inv_y_des) || 0;
        promedio.asistencia += parseFloat(item.hours_asi_tec) || 0;
        promedio.perfeccionamiento += parseFloat(item.hours_perf) || 0;
        promedio.administracion += parseFloat(item.hours_admin) || 0;
        promedio.extension += parseFloat(item.hours_extencion) || 0;
        promedio.educacion += parseFloat(item.hours_educ) || 0;
      });

      // Calcular el promedio dividiendo por el número de académicos
      const numAcademicos = academicos.length;
      Object.keys(promedio).forEach(key => {
        promedio[key] = +(promedio[key] / numAcademicos).toFixed(2);
      });

      return [
        promedio.docencia,
        promedio.investigacion,
        promedio.asistencia,
        promedio.perfeccionamiento,
        promedio.administracion,
        promedio.extension,
        promedio.educacion
      ]
    },
    filterByUnit() {

      if (this.selected_unit.cost_center === 40) {
        this.indicator_state = this.indicator_state_faculty
        this.series_pie = this.indicator_state
        this.$refs.apexChartComponent.updateSeries([
          {
            name: "Horas Promedio",
            data: this.prom_total_eq
          }
        ]);
        if(this.filtroActivo){
          const filtroAux = this.filtroActivo
          this.filtroActivo = null
          this.aplicarFiltro(filtroAux)
        }
      }
      else{
        const data_unit = this.data_faculty.find(x => x.unit.id === this.selected_unit.id)
        this.indicator_state = data_unit.indicator_state
        this.series_pie = this.indicator_state
        this.$refs.apexChartComponent.updateSeries([
          {
            name: "Horas Promedio",
            data: data_unit.prom_total_eq_sem
          }
        ]);
        if(this.filtroActivo){
          const filtroAux = this.filtroActivo
          this.filtroActivo = null
          this.aplicarFiltro(filtroAux)
        }
      }

    }

  }
}

</script>


<style scoped>
.card-stretch {
  height: 100%; /* Hace que la tarjeta ocupe todo el espacio de la columna */
  display: flex; /* Asegura que utilice flexbox */
  flex-direction: column; /* Mantén la disposición de los elementos en columna */
}

.columns {
  width: 100%; /* Asegura que las columnas mantengan sus proporciones */
}

.card-content {
  flex: 1; /* Ajusta la altura del contenido de las tarjetas sin alterar su ancho */
}

.card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card.is-selected {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  border: 3px solid #3273dc; /* Color primario de Bulma */
}

</style>